import React ,{useEffect,useState} from "react";
import { View } from "react-native";
import { getConfigurations } from "../../api/serviceRequest";
import {  CreateResponsiveStyle,   DEVICE_SIZES, } from "rn-responsive-styles";
 
export default function CarLoanIndex(props){
    const styles = useStyles()
    const [uclLink,setUclLink] = useState(global.UCLURL)

    useEffect(()=>{
        if(!global.UCLURL){loadDefaultConfig()}
      },[])
    const loadDefaultConfig = () => {
        getConfigurations().then((res)=>{
          if(res.statusCode == 200) {
            const used_car_loan_url  = res?.data.find((configItem) => configItem.key == "used_car_loan_url");
            if (used_car_loan_url) {
                setUclLink(used_car_loan_url.value)
                global.UCLURL = used_car_loan_url.value;
              }
          }
        }).catch((err)=>{})
    }
    return(
        <>
            <View style= {styles.contentWrapper}>
            <iframe src={uclLink} title="" width="100%" height="400"></iframe>
            </View>
        </>
            
    )
}
    const useStyles = CreateResponsiveStyle({
    contentWrapper : {
        display : "flex",
        flexDirection :"row",
        alignItems :"center",
        paddingTop : 20,         
        justifyContent : "space-between",
    },
}, 
{
        [DEVICE_SIZES.LG]: {},
        [DEVICE_SIZES.MD]: { },
        [DEVICE_SIZES.SM]: {},
        [DEVICE_SIZES.XS]: {
            contentWrapper : {
                flexDirection:"column",
               
            },
        }
    }
)
